<template>
    <div class="bid-modal modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card" v-if="!showTerms">
            <header class="modal-card-head" v-if="false">
                <img :src="'/static/images/manufacturers/' +  activeLot.company + '.png'" style="float: left; margin-right: 10px;" width="50">
                <strong class="has-text-primary" style="padding-right: 5px;">{{ activeLot.company }}</strong><strong>{{ activeLot.model_name }}</strong>
            </header>
            <section class="modal-card-body" v-if="true">
                <div class="theme-table-container table-container center-column">
                    <table class="auction-table theme-table table is-striped is-narrow is-hoverable is-scrollable is-fullwidth"
                           id="enquiry-table">
                        <thead>
                        <tr class="top-header" id="resultTable">
                            <th>Photo</th>
                            <th>Lot No</th>
                            <th>Date</th>
                            <th>Model</th>
                            <th>Grade</th>
                            <th>Price</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="picture-td" data-label="photo">
                                <div class="image is-64x64">
                                    <img :src="activeLot.pictures.split('#')[1] + '&w=320'" @error="imgUrlAlt($event)">
                                </div>
                            </td>
                            <td>{{ activeLot.bid }}</td>
                            <td>{{ activeLot.lot_date }}</td>
                            <td>{{ activeLot.company }} {{ activeLot.model_name_en }}</td>
                            <td>{{ activeLot.grade_en }}</td>
                            <td>{{ activeLot.start_price | formatNumber }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="notification is-danger" v-if="errorStatus">
                    <p>{{ errorMessage }}</p>
                </div>
                <bid-input></bid-input>
                <div class="form-row-bid">
                    <group-select></group-select>
                    <group-wins-select></group-wins-select>
                </div>
                <group-remarks-input></group-remarks-input>
                <inland-cost></inland-cost>

                <div class="tems-condition">
                    <ul class="is-size-7">
                        <li>
                            <strong>Important!</strong> By pushing "Place Bid", you accept <a v-on:click="showTerms = true">Terms & Conditions of Use.</a>
                        </li>
                    </ul>
                </div>
            </section>
            <section class="modal-card-body" v-if="false">
                <h3>Loading...</h3>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-info" v-if="lotHasBid" @click="updateBid"  :class="{ 'is-loading': isLoading }" :disabled=isDisabled>Update Bid</button>
                <button class="button is-primary" v-if="!lotHasBid && bidAllowed" @click="placeBid" :class="{ 'is-loading': isLoading }" :disabled="isDisabled">Place Bid</button>
                <button class="button" @click="closeBidModal()" :disabled="isLoading">Close</button>
                <span class="ml-10 paypal-img" @click="openModal"><img src="@/assets/paypal.png"></span>
            </footer>
        </div>
        <div class="modal-card" style="width: 90%;" v-if="showTerms">
            <header class="modal-card-head">
                <p class="modal-card-title">Terms and Conditions</p>
            </header>
            <section class="modal-card-body">
                <terms></terms>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-primary" @click="showTerms = false">Back</button>
            </footer>
        </div>
        <div class="modal" :class="{'is-active' : isActive }">
            <div class="modal-background" @click="closeModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Transactions</p>
                    <button class="delete" aria-label="close" @click="closeModal"></button>
                </header>

                <section class="modal-card-body">
                    <p class="has-text-success" v-if="getSuccess">{{ paymentMsg }}</p>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="no-wrap">Add Deposits</label>
                        </div>
                        <div class="field-body mr-10">
                            <div class="field has-addons">
                                <div class="control">
                                    <input v-model="amount_yen" v-on:keyup="convertYen()" class="input" type="number" placeholder="Amount">
                                </div>
                                <p class="control">
                                    <a class="button is-static">
                                        000 ¥
                                    </a>
                                </p>
                                <div class="control">
                                    <input class="input" type="number" v-on:keyup="convertUsd()" placeholder="Amount" v-model="amount_usd">
                                </div>
                                <p class="control">
                                    <a class="button is-static">
                                        $
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div class="field-submit">
                            <div ref="paypal"></div>
                        </div>
                    </div>
                    <table class="table is-striped is-narrow is-hoverable is-fullwidth">
                        <thead>
                        <tr>
                            <th>Transaction</th>
                            <th>Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td colspan="2" class="has-text-centered">Coming soon...</td>
                        </tr>
                        </tbody>
                    </table>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="closeModal">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import Terms from './Terms'
    import InlandCost from './InlandCost'
    import BidInput from './Inputs/BidInput'
    import GroupSelect from './Inputs/GroupSelect'
    import GroupWinsSelect from './Inputs/GroupWinsSelect'
    import GroupRemarksInput from './Inputs/GroupRemarksInput'
     import apiBids from '../../../../api/apiBids'
    import apiRates from '../../../../api/apiRates'
    export default {
        components: {
            Terms,
            InlandCost,
            BidInput,
            GroupSelect,
            GroupWinsSelect,
            GroupRemarksInput,
        },
        data() {
            return {
                showTerms: false,
                modalStatus: false,
                amount_yen: '',
                amount_usd: '',
                paymentMsg: '',
                paypalClient: {
                    sandbox: 'ASqta9ZOOfiQLr_z4iniwYPJvsJ1Atk45zd82fTaI023ND8I9u5pBKvBi60QImFcob1V6dxfQBq7-qvY',
                    production: 'AaxhtJJA0nr5yaI-6GppVrCVqTCDWt_8sqGPio39eabV5HVKH2tqHBb5FX0up_GYaUwFMVG9oG-f1Kxu'
                }
            }
        },
        computed: {
            activeLot() {
                return this.$store.getters.getResultActiveBiddingModalLot
            },
            lotHasBid() {
                return this.$store.getters.getResultActiveBiddingModalLot.bids.length > 0
            },
            bidAllowed() {
                return this.$store.getters.getGroupSettings.max_groups > 0
            },
            isLoading() {
                return this.$store.getters.getResultActiveBiddingModalLoadingStatus
            },
            errorStatus() {
                return this.$store.getters.getResultActiveBiddingModalErrorStatus
            },
            errorMessage() {
                return this.$store.getters.getResultActiveBiddingModalErrorMessage
            },
            isDisabled() {
                return this.$store.getters.getResultActiveBiddingModalDisabledStatus
            },
            isActive() {
                return this.modalStatus
            },
            getSuccess(){
                return this.$store.getters.getPaymentData
            }
        },
        methods: {
            openModal() {
                this.modalStatus = true
            },
            convertYen() {
                setTimeout(function () {
                    //this.$store.dispatch('changePlaceBidLoadingStatus', true)
                    const query = {amount_yen: this.amount_yen}
                    apiRates
                        .convertYenRequest(query)
                        .then((response) => {
                            this.amount_usd = response.data
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }.bind(this), 1000)
            },
            convertUsd() {
                setTimeout(function () {
                    //this.$store.dispatch('changePlaceBidLoadingStatus', true)
                    const query = { amount_usd: this.amount_usd }
                    apiRates
                        .convertUsdRequest(query)
                        .then((response) => {
                            this.amount_yen = response.data
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }.bind(this), 1000)
            },
            placeBid() {
                this.$store.dispatch('changeResultActiveBiddingModalCurrentBidGroup')
                this.$store.dispatch('changeResultActiveBiddingModalErrorStatus', false)
                apiBids
                    .placeBidRequest(this.$store.getters.getResultActiveBiddingModalCurrentBid)
                    .then((response) => {
                        if (response.status === 200){
                            this.$store.dispatch('changeSearchResultActiveLotBids', [response.data])
                            this.$store.dispatch('resetResultBiddingModal')
                        }
                    })
                    .catch((err) => {
                        console.log(err.response)
                        this.$store.dispatch('changePlaceBidLoadingStatus', false)
                        this.$store.dispatch('changeResultActiveBiddingModalErrorStatus', true)
                        this.$store.dispatch('changeResultActiveBiddingModalErrorMessage', err.response.data.bid)
                    })
            },
            updateBid() {
                this.$store.dispatch('changeResultActiveBiddingModalCurrentBidGroup')
                this.$store.dispatch('changeResultActiveBiddingModalErrorStatus', false)
                apiBids
                    .updateBidRequest(this.$store.getters.getResultActiveBiddingModalCurrentBid)
                    .then((response) => {
                        this.$store.dispatch('changeSearchResultActiveLotBids', [response.data.original])
                        this.$store.dispatch('resetResultBiddingModal')
                    })
                    .catch((err) => {
                        console.log(err.response)
                        this.$store.dispatch('changePlaceBidLoadingStatus', false)
                        this.$store.dispatch('changeResultActiveBiddingModalErrorStatus', true)
                        this.$store.dispatch('changeResultActiveBiddingModalErrorMessage', err.response.data.bid)
                    })
            },
            closeBidModal() {
                this.$store.dispatch('resetResultBiddingModal')
            },
            closeModal() {
                this.modalStatus = false
            },
            setLoaded: function() {
                this.loaded = true;

                window.paypal
                    .Buttons({
                        createOrder: (data, actions) => {
                            if(this.amount_usd) {
                                return actions.order.create({
                                    purchase_units: [
                                        {
                                            description: 'Deposits in UNET',
                                            amount: {
                                                currency_code: "USD",
                                                value: this.amount_usd
                                            }
                                        }
                                    ]
                                });
                            }
                        },
                        onApprove: async (data, actions) => {
                            const order = await actions.order.capture();
                            if(order){
                                this.$store.dispatch('payment', order);

                                this.amount_usd = '';
                                this.amount_yen = '';
                                this.paymentMsg = 'Payment Successful';
                                console.log(order);
                            }
                        },
                        onError: err => {
                            console.log(err);
                        }
                    })
                    .render(this.$refs.paypal);
            }
        },
        created() {
            const script = document.createElement("script");
            script.src =
                "https://www.paypal.com/sdk/js?disable-funding=credit,card&client-id="+this.paypalClient.production;
            script.addEventListener("load", this.setLoaded);
            document.body.appendChild(script);
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/BiddingModal/BidModal.vue